export default function UploadStatus({ latestUpload }) {
  if (!latestUpload) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-gray-400">
        <div className="w-1.5 h-1.5 rounded-full bg-gray-300" />
        No CSV uploads yet
      </div>
    );
  }

  const uploadDate = new Date(latestUpload.uploaded_at);
  const now = new Date();
  const diffDays = Math.floor((now - uploadDate) / (1000 * 60 * 60 * 24));

  let agoText;
  if (diffDays === 0) agoText = 'today';
  else if (diffDays === 1) agoText = 'yesterday';
  else agoText = `${diffDays}d ago`;

  const isStale = diffDays > 7;

  return (
    <div className={`flex items-center gap-1.5 text-xs ${isStale ? 'text-red-600' : 'text-gray-400'}`}>
      <div className={`w-1.5 h-1.5 rounded-full ${isStale ? 'bg-red-500' : 'bg-emerald-500'}`} />
      <span>
        Last upload: <span className="font-medium">{latestUpload.filename}</span> ({agoText})
      </span>
    </div>
  );
}
